<template>
  <div
    class="block-contacts-container"
    :class="[device_platform]"
  >
    <div class="content">
      <div class="content-place">
        <div class="panel-container">
          <div class="img-salon" />
          <h3>
            Топ-2* Лучших дилеров по продажам в Центральном федеральном округе.
          </h3>
          <div class="location">
            <div class="location__img"></div>
            <div class="location__text">
              {{ CONSTANTS.address }}
            </div>
            <div class="location__text">
              {{ CONSTANTS.worktimes }}
            </div>
          </div>
          <callback-form
            class="callback-form"
            v-on="$listeners"
            :data="{ type: 'sale', form: 'contacts' }"
            btn_theme="button_theme_secondary"
          >
            Получить предложение
          </callback-form>
        </div>
        <div class="flex-placeholder"></div>
      </div>
      <div id="ya-karto"></div>
    </div>
  </div>
</template>

<script>
import Mask from "../common/mask";
import Mixin from "../common/mixin";
import Keyup from "../common/keyup";
import CallbackForm from "./callback-form";
import placemarkImg from "../images/utils/placemark.svg";

export default {
  name: "",
  components: { CallbackForm },
  directives: { Mask, Keyup },
  mixins: [Mixin],
  props: [""],
  data() {
    return {};
  },
  mounted() {
    this.$nextTick(this.waitYmaps);
  },
  computed: {},
  methods: {
    initYandexMap() {
      const isMobile = {
        Android: function () {
          return navigator.userAgent.match(/Android/i);
        },
        BlackBerry: function () {
          return navigator.userAgent.match(/BlackBerry/i);
        },
        iOS: function () {
          return navigator.userAgent.match(/iPhone|iPad|iPod/i);
        },
        Opera: function () {
          return navigator.userAgent.match(/Opera Mini/i);
        },
        Windows: function () {
          return navigator.userAgent.match(/IEMobile/i);
        },
        any: function () {
          return (
            isMobile.Android() ||
            isMobile.BlackBerry() ||
            isMobile.iOS() ||
            isMobile.Opera() ||
            isMobile.Windows()
          );
        },
      };
      let zoomControl = new ymaps.control.ZoomControl({
        options: {
          position: {
            left: "auto",
            right: 10,
            top: 108,
          },
        },
      });
      let center_x =
        this.device_platform === "phone"
          ? this.CONSTANTS.coords.x_center_small
          : this.CONSTANTS.coords.x_center_big;

      let myMap = new ymaps.Map(
        "ya-karto",
        {
          center: [this.CONSTANTS.coords.y_center, center_x],
          zoom: 16,
          controls: [],
        },
        {
          searchControlProvider: "yandex#search",
        }
      );
      myMap.controls.add(zoomControl);

      myMap.geoObjects.add(
        new ymaps.Placemark(
          [this.CONSTANTS.coords.y_salon, this.CONSTANTS.coords.x_salon],
          {
            iconContent: this.CONSTANTS.salon_name,
            balloonContent: `<div>${this.CONSTANTS.salon_name}</div>>`,
          },
          {
            iconLayout: "default#image",
            iconImageHref: placemarkImg,
            iconImageSize: [28, 40],
            iconImageOffset: [-14, -40],
          }
        )
      );
      if (isMobile.any() || this.device_platform !== "desktop") {
        myMap.behaviors.disable("drag");
      }
      myMap.behaviors.disable("scrollZoom");
    },
    waitYmaps() {
      let script = document.createElement("script");
      script.src = "//api-maps.yandex.ru/2.1/?load=package.standard&lang=ru_RU";
      document.head.appendChild(script);
      script.onload = () => {
        ymaps.ready(this.initYandexMap);
      };
    },
  },
};
</script>

<style scoped lang="scss">
@import "../styles/constants.scss";

.callback-form {
  margin: 0 60px;
}

.block-contacts-container {
  margin-top: calcFontSize(0, 90, 320, 1920);
  width: 100%;

  h3 {
    font-weight: bold;
    margin-top: 20px;
  }
}

.content {
  position: relative;
}

.content-place {
  max-width: 1300px;
  margin: auto;
  display: flex;
  justify-content: space-between;
  height: 100%;
  align-items: center;
  position: relative;
  flex-wrap: wrap;
}

#ya-karto {
  width: 100%;
  height: calcFontSize(333, 664, 320, 1920);
  position: absolute;
  top: 0;
}

.panel-container {
  padding: 32px 35px 34px;
  margin-bottom: calcFontSize(20, 220, 720, 1920);
  position: relative;
  z-index: 1;
}

.img-salon {
  background: url("../images/logo/avtomir.svg") no-repeat center;
  width: 233px;
  height: 50px;
  background-size: contain;
}

.img-vendor {
  height: 46px;
  width: 116px;
  background-size: contain;
}

.location {
  margin: 20px 0 calcFontSize(20, 44, 320, 1920);
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.location__text {
  font-size: 14px;
}

@media (max-width: 720px) {
  .block-contacts-container {
    margin-top: unset;
  }

  .img-salon {
    display: none;
  }

  .location {
  }

  .panel-container {
    margin: calcFontSize(333, 664, 320, 1920) 0 40px;
    width: 100%;
    max-width: unset;
    box-shadow: unset;
  }
}
</style>
